import "./footer.css";

export function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <p>© 2026 La Estrella Poda </p>
      </div>
    </footer>
  );
}